module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Qr-009ad2f2143a3291640ef596d387bc93.svg";